import React, { forwardRef, useMemo } from "react";
import InlinePdfSpread from "./InlinePdfSpread";
import InlineImageSpread from "./InlineImageSpread";

/**
 * InlineEbookSpread
 * ตัวกลางในการเลือกระหว่างโหมด PDF และโหมดรูปภาพ (Gallery)
 */
const InlineEbookSpread = forwardRef(function InlineEbookSpread(
  {
    mode = "auto",     // "auto" | "pdf" | "images"
    fileUrl,           // URL ของ PDF (String) หรือข้อมูลดิบ { data: Uint8Array } (Object)
    imagePages = [],   // array ของ URL รูปภาพ
    ...restProps       // props อื่นๆ เช่น viewportHeight, stackDirection
  },
  ref
) {
  const resolvedMode = useMemo(() => {
    // 1. ถ้ามีการระบุโหมดมาโดยตรง ให้ใช้โหมดนั้น
    if (mode !== "auto") return mode;
    
    // 2. ถ้ามีชุดรูปภาพ (Gallery) ให้เลือกโหมด images เป็นอันดับแรก
    if (imagePages && imagePages.length > 0) return "images";
    
    // 3. ตรวจสอบข้อมูลใน fileUrl
    if (fileUrl) {
      /**
       * ✅ [แก้ไข] ตรวจสอบประเภทข้อมูลของ fileUrl
       * กรณีเป็นไฟล์ภายใน Omeka S: fileUrl จะเป็น String (URL)
       * กรณีเป็นไฟล์ภายนอก: fileUrl จะเป็น Object ({ data: Uint8Array }) จาก Proxy
       */
      if (typeof fileUrl === "string") {
        return fileUrl.toLowerCase().endsWith(".pdf") ? "pdf" : "pdf";
      }
      
      if (typeof fileUrl === "object") {
        // หากได้รับข้อมูลดิบผ่านมา ให้สันนิษฐานว่าเป็น PDF ทันที
        return "pdf";
      }
    }
    
    return "pdf";
  }, [mode, fileUrl, imagePages]);

  // แสดงผลตามโหมดที่เลือก
  if (resolvedMode === "images") {
    return (
      <InlineImageSpread
        ref={ref}
        pages={imagePages}
        {...restProps}
      />
    );
  }

  // โหมดเริ่มต้น: PDF
  return (
    <InlinePdfSpread
      ref={ref}
      fileUrl={fileUrl}
      {...restProps}
    />
  );
});

export default InlineEbookSpread;